$(document).ready(function() {

	// FAQ section accordion
	var $question = $('.js-question');

	$question.on('click', function () {
		var wasOpen = $(this).hasClass('active');
		$question.removeClass('active');
		if(!wasOpen) $(this).addClass('active');
	});

	// Scroll to content
	$('#js-arrow-box').on('click', function(e) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: $($(this).attr('href')).offset().top
		},
		500);
	});

	function setTopHeight() {
		$top.height($window.height() - $header.height() + 'px');
	}

	// Show floatbar
	var $downloadButton = $('#js-download-button'),
		$window = $(window),
		$document = $(document);

	if ($downloadButton.length > 0) {
		$window.on('resize scroll', function() {
			if ($document.scrollTop() > $downloadButton.offset().top + 70) {
				$('#floatbar').addClass('sticky');
			} else {
				$('#floatbar').removeClass('sticky');
			}
		});
	}
});

(function(){
	var browserRefs = ['google', 'bing'],
		$build = $('[data-alt-build]'),
		$anchors = $('[data-bi-download-name]');
		getReferrer = function () {
			var referrer = document.referrer;
			var path = referrer.split('/').filter(function (val) {
				return val.trim();
			});

			if (path.length > 1) {
				referrer = path[1];
			}

			if (referrer.length === 0) {
				return false;
			}

			return referrer;
		},
		validateReferrer = function (referrer) {
			var isValid = false;

			if (referrer) {
				$.each(browserRefs, function(key, el){
					if (referrer.indexOf(el) > -1) {
						isValid = true;
					}
				});
			}

			return isValid;
		},
		hasUTMs = function () {
			var url = window.location.href;
			if (url.indexOf('utm_campaign') > -1 || url.indexOf('GCLID') > -1) {
				return true;
			} else {
				return false;
			}
		};

	var referrer = getReferrer();

	if (validateReferrer(referrer) && !hasUTMs()) {
		if ($anchors.length > 0 && $build.length > 0) {
			var build = $build.data('alt-build');

			$anchors.each(function(key, el){
				var oldBuild = $(el).data('bi-download-name');
				var href = $(el).attr('href').replace(oldBuild, build);

				$(el).attr('href', href);
				$(el).attr('data-bi-download-name', build);
			});
		}
	}

})();
